module.exports = __webpack_public_path__ + "components/nearby-points/static/photo-8-87bea697b810869903153219325e5952.jpg";